﻿import { IgnoreChanges, NodeReference } from '../decorators/change-tracker';
import { Kb3dModel } from '../decorators/kb3d-decorator';
import { instanceOf } from '../decorators/model-utils';
import { eMateType } from '../enums';
import { BaseConnector } from '../features';
import { IMateNode } from '../kb3d-models';
import { Kb3dObject } from '../kb3d-object';
import { Token } from '../token';

@Kb3dModel<MateNode>({
    token: Token.MateNode,
    validate: (n, v) => {
        if (n.changes.hasAny('connector1', 'connector2')) {
            v.assert(
                n,
                'connector1',
                n.connector1 != null && n._manager?.getById(n.connector1) != null,
                'Connector is required'
            );
            v.assert(
                n,
                'connector2',
                n.connector2 != null && n._manager?.getById(n.connector2) != null,
                'Connector is required'
            );
            v.assert(
                n,
                'connector2',
                n._manager?.getById(n.connector1)?._parent !== n._manager?.getById(n.connector2)?._parent ||
                    n._manager?.getById(n.connector1) == null,
                'Connectors cannot have the same parent node'
            );
        }
    },
})
export class MateNode extends Kb3dObject implements IMateNode {
    constructor() {
        super();
    }

    enabled: boolean;
    mateType: eMateType;
    @NodeReference(BaseConnector, 'position', 'direction', 'angle') connector1: string;
    @NodeReference(BaseConnector, 'position', 'direction', 'angle') connector2: string;
    flip: boolean;
    offsetX: number;
    offsetY: number;
    offsetZ: number;
    offsetAngle: number;

    /** used internally when processing mates to control whether c1/c2 need to be swapped */
    @IgnoreChanges
    _swap: boolean;

    getC1() {
        return this._manager?.getById<BaseConnector>(this.connector1);
    }
    getC2() {
        return this._manager?.getById<BaseConnector>(this.connector2);
    }
    isActive() {
        return this.enabled && this.getC1() != null && this.getC2() != null;
    }
}

export function isMate(node: Kb3dObject): node is MateNode {
    return instanceOf(node, Token.MateNode);
}
